import { breakableSpaces } from "../../model/html-text";
import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { CommentsService } from "../../services/comments.service";
import { AuthService } from "../../auth.service";
import { Router } from "@angular/router";
import { Messages } from "../../model/messages";
import { Comment } from "../../model/comments";
import { Navigation } from "../../model/navigation";
import { Ticket } from "../../model/ticket";
import { FormGroup } from "@angular/forms";

import { TicketService } from "../../services/ticket.service";
import { NavigationHelper } from "../../services/navigation.helper";
import { UsersService } from "../../services/users.service";

@Component({
    selector: "comments",
    templateUrl: "./comments.component.html",
    styleUrls: ["./comments.component.css"],
})
export class CommentsComponent implements OnInit {
    messages: BehaviorSubject<Messages>;
    @Output() commentSelected = new EventEmitter<number>();
    ticket = new BehaviorSubject<Ticket>(Ticket.EMPTY);
    @Input() isMobile: boolean = false;
    comments: BehaviorSubject<Comment[]>;
    selectedComment: Comment | null = null;
    editMode: boolean = false;
    title: BehaviorSubject<string> = new BehaviorSubject<string>(
        "comments.title"
    );
    @Input() currentTicket: Observable<Ticket>;
    currentId: number | null;
    commentsTitle: string = "commentsDetails.title.comments.details";
    comment = new BehaviorSubject<Comment>(new Comment(0, 0, "", ""));
    showCreateForm: boolean = true;
    commentsForm: FormGroup;
    showDetails: boolean = false;

    constructor(
        private commentsService: CommentsService,
        private authService: AuthService,
        private router: Router,
        private ticketService: TicketService,
        private nav: NavigationHelper,
        public user: UsersService
    ) {
        this.messages = new BehaviorSubject(Messages.EMPTY);
        this.comments = new BehaviorSubject<Comment[]>([]);
    }

    ngOnInit(): void {
        this.title.next("comments.title");
        const token = this.authService.token;
        if (this.currentTicket) {
            this.currentTicket.subscribe((ticket) => {
                this.currentId = ticket.id;

                if (this.currentId && this.currentId > 0) {
                    const comments = ticket.parts?.comments;

                    this.commentsService.accept(comments);
                    this.commentsService.select(Comment.EMPTY);
                }
            });
            this.commentsService.commentsObservable.subscribe((comments) => {
                if (comments) {
                    const sortedComments = [...comments].sort((a, b) => b.id - a.id);
                    this.comments.next(sortedComments);
                }
            });
        }
        this.nav.fragmentId.subscribe((id) => {
            const fragmentId = Number(id);

            if (this.nav.currentFragmentTopic === "comment") {
                if (id === "-9") {
                    this.showCreateForm = true;
                    this.editMode = true;

                    const newComment = new Comment(Navigation.NEW, null, "", "");
                    this.selectedComment = null;
                    this.commentsService.select(newComment);
                } else if (fragmentId > 0) {
                    this.showCreateForm = false;
                    const found = this.comments.value.find((t) => t.id === fragmentId);

                    if (found) {
                        this.selectedComment = found;
                        this.commentsService.select(found);

                        const action = this.nav.currentAction;

                        if (action === "fragment") {
                            this.showDetails = true;
                        } else if (action === "fragmentedit") {
                            this.showDetails = true;
                            this.editMode = true;
                        }
                    }
                }
            }
        });
    }
    selectAndNavigate(comment: Comment): void {
        this.showCreateForm = false;
        this.selectedComment = comment;
        this.commentsService.select(comment);
        this.editMode = true;

        const commentId: number = comment.id;
        const url =
            "tickets/" + this.currentId + "/fragmentedit/comment/" + commentId;

        if (commentId) {
            this.router.navigate([url]).then(() => {
                this.commentSelected.emit(commentId);
            });
        }
    }
    sanitizeContent(content: string): string {
        return content ? breakableSpaces(content.replace(/<p>/g, "").replace(/<\/p>/g, "<br>")) : "";
    }
    editComment(comment: Comment, event: Event): void {
        event.stopPropagation();

        if (this.selectedComment && this.selectedComment.id === comment.id) {
            this.cancelEdit(event);
            return;
        }

        this.showCreateForm = false;
        this.selectedComment = comment;
        this.commentsService.select(comment);
        this.editMode = true;

        const commentId: number = comment.id;
        const url = `tickets/${this.currentId}/fragmentedit/comment/${commentId}`;

        this.router.navigate([url]).then(() => {
            this.commentSelected.emit(commentId);
        });
    }

    cancelEdit(event: Event): void {
        event.stopPropagation();

        this.selectedComment = null;
        this.editMode = false;
        this.showCreateForm = true;
        this.commentsService.select(new Comment(Navigation.NEW, 0, "", ""));

        const url = `tickets/${this.currentId}/fragment/comment`;
        this.router.navigate([url]);
    }


    createComment(): void {
        this.selectedComment = null;
        this.showCreateForm = true;
        const newComment = new Comment(Navigation.NEW, 0, "", "");
        this.commentsService.selectedComment.next(newComment);

        const url =
            "tickets/" + this.currentId + "/fragmentedit/comment/" + Navigation.NEW;

        this.router.navigate([url]).then(() => {
            this.commentSelected.emit(Navigation.NEW);
        });
    }
    get commentId(): number {
        const comment = this.comment.value;
        return comment && comment.id ? comment.id : Navigation.NEW;
    }
}
